import { Button, ButtonGroup, Box, Text, Link, VStack } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { formatDateTime, Modal, isSafeUrl } from 'shared-components';

interface InterviewDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  interviewName?: string | null;
  description?: string | null;
  startDate?: number;
  joinUrl?: string;
}

export const InterviewDetailsModal = ({
  isOpen,
  onClose,
  interviewName,
  description,
  startDate,
  joinUrl,
}: InterviewDetailsModalProps): ReactElement => {
  const title = interviewName ? `${interviewName} details` : 'Interview details';
  const shouldRenderUrl = joinUrl && isSafeUrl(joinUrl);

  return (
    <Modal
      show={isOpen}
      onClose={onClose}
      title={title}
      footer={
        <ButtonGroup spacing={3} size="lg">
          <Button onClick={onClose}>Close</Button>
        </ButtonGroup>
      }
    >
      <VStack align="stretch" spacing={4}>
        {startDate && (
          <Box>
            <Text fontWeight="semibold" mb={1}>
              Date &amp; time
            </Text>
            <Text>{formatDateTime(new Date(startDate))}</Text>
          </Box>
        )}

        {description && (
          <Box>
            <Text fontWeight="semibold" mb={1}>
              Description
            </Text>
            <Text>{description}</Text>
          </Box>
        )}

        {shouldRenderUrl && (
          <Box>
            <Text fontWeight="semibold" mb={1}>
              Booking details
            </Text>
            <Link href={joinUrl} isExternal>
              {joinUrl}
            </Link>
          </Box>
        )}
      </VStack>
    </Modal>
  );
};
